import { Component, OnInit } from '@angular/core';
import { HttpclientService } from 'src/app/services/httpclient.service';
import { EdiEdpar } from 'src/app/model/ediEdpar';
import { FileExportService } from 'src/app/services/file-export.service';
import { AppSettingService } from 'src/app/services/app-setting.service';
import { PoOrderByPipe } from 'src/app/pipes/po-order-by.pipe';
import { DatePipe } from '@angular/common';
import { PdfFileService } from 'src/app/services/pdf-file.service';
import { ExcelFileService } from 'src/app/services/excel-file.service';
import { ConfirmDialogService } from 'src/app/services/confirm-dialog.service';
declare var $: any;
@Component({
  selector: 'app-edi-edpar',
  templateUrl: './edi-edpar.component.html',
  styleUrls: ['./edi-edpar.component.css']
})
export class EdiEdparComponent implements OnInit {

  public loading: boolean;
  selectedpartner : String = "";
  selectedpartnerid : String = "";
  partners : any;
  search: string = "";
  selectedAllRow: boolean;
  config: any;
  count: number = 25;
  exportList: string[] = ['PDF', 'Excel'];
  selectedEdiEdpars: any = [];
  exportModal: string;
  modalPopup : boolean=false;
  edpar: EdiEdpar[];
  serachdetails: EdiEdpar[];
  edpardetails: EdiEdpar[];
  clonedEdparDetails: EdiEdpar[];
  public intialEdiEdparList: EdiEdpar[];

  isedparupdated : string="";
  updatedediedpar : boolean;
  isindirectContactTemplateCd : boolean;
  isdirectOrdersAllowedFlg : boolean;
  ediTpId:string;
  ediTpShiptoCd:string;
  sapPayerNum:string;
  sapShiptoNum:string;
  indirectContactTemplateCd:string;
  directOrdersAllowedFlg:string;

  isCreateDateSortCollapsedUpArrow:boolean;
  isCreateDateSortCollapsedDownArrow:boolean;

  isEdiTpIdSortCollapsedUpArrow:boolean;
  isEdiTpIdSortCollapsedDownArrow:boolean;

  isEdiTpShiptoCdSortCollapsedUpArrow:boolean;
  isEdiTpShiptoCdSortCollapsedDownArrow:boolean;

  isSapPayerNumSortCollapsedUpArrow:boolean;
  isSapPayerNumSortCollapsedDownArrow:boolean;

  isSapShiptoNumSortCollapsedUpArrow:boolean;
  isSapShiptoNumSortCollapsedDownArrow:boolean;

  isIndirectContactTemplateCdSortCollapsedUpArrow:boolean;
  isIndirectContactTemplateCdSortCollapsedDownArrow:boolean;

  isDirectOrdersAllowedFlgSortCollapsedUpArrow:boolean;
  isDirectOrdersAllowedFlgSortCollapsedDownArrow:boolean;

  constructor(private httpclientService: HttpclientService,public fileExportService: FileExportService,
    public appSettingService: AppSettingService,private pipe: PoOrderByPipe,public pdfFileService: PdfFileService,
    public excelFileService: ExcelFileService, public datePipe: DatePipe,private confirmDialogService: ConfirmDialogService) { 
    this.config = {
      currentPage: 1,
      itemsPerPage: 25
    };
  }

  
  ngOnInit() { 
    $(document).ready(
      () => {
        let searchInp = $(".searchContr .searchInput");
        let searchCloseIcon = $(".searchCloseIcon")
        $(searchInp).on("focus", function () {
          $(".searchIcon").addClass("searchIconActive")
          $(".searchCloseIcon").fadeIn("slow")
        })
        $(searchInp).on("blur", function () {
          $(".searchIcon").removeClass("searchIconActive")
          $(".searchCloseIcon").fadeOut("slow")
        })
        $(searchCloseIcon).hover(function () {
          $(searchCloseIcon).toggleClass("searchCloseIconFocus")
        })
        $(searchCloseIcon).on("click", function () {
          $(".searchContr .searchCloseIcon").val("");
          $(".searchInput").val("");

        })
        
      }
    )
  //   this.loading=true;
  //   this.httpclientService.getPartnerListMSO().subscribe(
  //     data => {
  //       this.partners = data;
  //     }
  // );

  this. getPartnerDataList();
  this.exportModal = this.appSettingService.exportList[0];
  this.onSearch();
  this.fileExportService.selectedEdiEdparData = [];
  }

  getPartnerDataList() {
    this.loading = true;
    if (this.appSettingService.partnerMSOGlobelList === null || this.appSettingService.partnerMSOGlobelList === undefined ) {
      this.httpclientService.getPartnerList().subscribe(
        data => {
          this.appSettingService.partnerMSOGlobelList = data;
          this.partners = data;
          console.log("data > "+data);
          this.loading = false;
        }
      );

      console.log('Partner is null from backend' + this.appSettingService.partnerMSOGlobelList);
      } else {
        this.partners = this.appSettingService.partnerMSOGlobelList;
        this.loading = false;
        console.log('Partner is not null from frontend' + this.appSettingService.partnerMSOGlobelList);
      }
  }

  ChangeSortOrder(exportData) {
    this.exportModal = exportData;
  }

  modalPopupExport : boolean=false;
  modalPopupString: string;
  pressingOKExport(){
    this.modalPopupExport=false;
    this.isedparupdated="";
  }
  export() {
    if(this.edpardetails == null || this.edpardetails == undefined || this.edpardetails.length==0){
      this.modalPopupString="No Data to Export";
      this.modalPopupExport=true;
      return;
    }
   
    let flag:boolean=false;
    if (this.fileExportService.selectedEdiEdparData.length === 0) {
      flag=true;
      this.edpar = [];
      this.edpardetails.forEach(pdto => {
        pdto.rowCheck = true;
        this.edpar.push(pdto);
      });
      this.edpardetails = this.edpar;
      this.fileExportService.selectedEdiEdparData = this.edpar;
    }
      if (this.exportModal === 'PDF') {
        this.pdfFileService.exportEdiEdparTable('EDPAR Table');
      } else if (this.exportModal === 'Excel') {
        this.selectedEdiEdpars = [];
        this.fileExportService.selectedEdiEdparData.forEach(pdto => {
          if (pdto.rowCheck) {
            let createDateTime: any;
            if(pdto.directOrdersAllowedFlg == null || pdto.directOrdersAllowedFlg == undefined ){
              pdto.directOrdersAllowedFlg="";
            }
            createDateTime = this.datePipe.transform(pdto.creationDate, this.appSettingService.globelDatePickerInUSAFormat);
            this.selectedEdiEdpars.push({
              'Create Date': `` + createDateTime, 'EDI TP ID': `${pdto.ediTpId}`, 'EDI Ship To': `${pdto.ediTpShiptoCd}`,
              'SAP Payer': `${pdto.sapPayerNum}`, 'SAP Ship To': `` + `${pdto.sapShiptoNum}`,
              'Template': `${pdto.indirectContactTemplateCd}`,'Direct Orders': `${pdto.directOrdersAllowedFlg.toUpperCase()}`
            });
          }
        });
        this.excelFileService.exportEdiEdparTableExcel(this.selectedEdiEdpars, 'EDPAR Table');
      }if(flag){
        this.edpar = [];
      this.edpardetails.forEach(pdto => {
        pdto.rowCheck = false;
        this.edpar.push(pdto);
      });
      this.edpardetails = this.edpar;
      this.fileExportService.selectedEdiEdparData = [];
      }
  }

  pageChanged(event) {
    this.config.currentPage = event;
  }
  pressingOK(){
    this.modalPopup=false;
    this.isedparupdated="";
    this.search="";
      // this.getediEdpar();
      this.ngOnInit();
      this.updatedediedpar = false;

  }
  pressingCancel(){
    this.modalPopup=false;
  }

  changerecordperpage(value) {

    this.config.itemsPerPage = value;
    this.count = value;
  }
  filteredData : any[]=[];
  onChangePartner1(){
    
    if(this.selectedpartner == "" ||  this.selectedpartner == null || this.selectedpartner == undefined){
      this.edpardetails=this.intialEdiEdparList;
    }else{
    this.edpardetails=this.intialEdiEdparList;
    var edpardetailsBasedOnPartnerSearch : EdiEdpar[]=[];
    var edpardetailsBasedOnPartnerSearchForLoop : EdiEdpar[]=[];
    edpardetailsBasedOnPartnerSearchForLoop=this.edpardetails;
    var len = edpardetailsBasedOnPartnerSearchForLoop.length;
    for(var i=0; i<len; i++){
     if(this.edpardetails[i].ediTpId == this.selectedpartner){
      edpardetailsBasedOnPartnerSearch.push(edpardetailsBasedOnPartnerSearchForLoop[i]);
      }
    }
    var filterLen = edpardetailsBasedOnPartnerSearch.length;
    
      this.edpardetails=[];
      this.edpardetails=edpardetailsBasedOnPartnerSearch;
    
    
    
  }
    
  }

  onChangePartner(){
    this.filteredData =[];
    this.selectedpartnerid=null
    if(this.intialEdiEdparList==undefined||this.intialEdiEdparList==null||this.intialEdiEdparList.length<1){
      this.loading = true;
      this.httpclientService.getEdiEdparDetails(this.search).then(
      (data)=> {
        this.loading = false;
          this.serachdetails=data;
          this.intialEdiEdparList = data;
          this.edpardetails=[];
          this.edpardetails=this.serachdetails;
          this.clonedEdparDetails= Object.assign([{}], this.serachdetails);
          this.clearAllSort();
          this.partners.forEach(element => {
            if(element.partnerName==this.selectedpartner)
            this.selectedpartnerid=element.partnerNumber;
          });
        this.intialEdiEdparList.forEach(element => {
        if(this.selectedpartnerid!=undefined&&this.selectedpartnerid!=null&&element.ediTpId==this.selectedpartnerid)
        this.filteredData.push(element);
      });
      this.edpardetails=[];
      if(this.filteredData!=null&&this.filteredData.length>0){
        this.serachdetails=this.filteredData;
                this.edpardetails=this.serachdetails;
                this.clonedEdparDetails= Object.assign([{}], this.serachdetails);
                this.clearAllSort();
      }else if(this.selectedpartnerid==undefined||this.selectedpartnerid==null){
        this.serachdetails=this.intialEdiEdparList;
        this.edpardetails=this.serachdetails;
        this.clonedEdparDetails= Object.assign([{}], this.serachdetails);
        this.clearAllSort();
      }
      }
  )
    }else{
      this.partners.forEach(element => {
        if(element.partnerName==this.selectedpartner)
        this.selectedpartnerid=element.partnerNumber;
      });
    this.intialEdiEdparList.forEach(element => {
    if(this.selectedpartnerid!=undefined&&this.selectedpartnerid!=null&&element.ediTpId==this.selectedpartnerid)
    this.filteredData.push(element);
  });
  this.edpardetails=[];
  if(this.filteredData!=null&&this.filteredData.length>0){
    this.serachdetails=this.filteredData;
            this.edpardetails=this.serachdetails;
            this.clonedEdparDetails= Object.assign([{}], this.serachdetails);
            this.clearAllSort();
  }else if(this.selectedpartnerid==undefined||this.selectedpartnerid==null){
    this.serachdetails=this.intialEdiEdparList;
    this.edpardetails=this.serachdetails;
    this.clonedEdparDetails= Object.assign([{}], this.serachdetails);
    this.clearAllSort();
  }
    }
  }
  cancelsearch(){
    this.isBlank=""
    this.edpardetails=this.clonedEdparDetails;
  }
  clearMessage(){
    this.isBlank=""
  }
  onChangeSearch(){
    this.selectedpartner="";
  }
  isBlank : string="";
  onSearch1(searchingData){
    if(searchingData.value === "" || searchingData.value === undefined || searchingData.value === null){
      this.isBlank="Please Enter Searching Data";
      return;
    }
    var filteredSerachDetails: EdiEdpar[]=[];
    var inputSearchingData = searchingData.value;
    var inputSearchingDataCheck = inputSearchingData.toLowerCase();
    var creationDate,ediTpId,ediTpShiptoCd,sapPayerNum,sapShiptoNum,indirectContactTemplateCd,directOrdersAllowedFlg;
    
    for(var edparDetail of this.edpardetails){
      if(edparDetail.creationDate != null && edparDetail.creationDate != undefined && edparDetail.creationDate !=""){
        creationDate =edparDetail.creationDate;
      }else{
        creationDate="";
      }
      if(edparDetail.ediTpId != null && edparDetail.ediTpId != undefined && edparDetail.ediTpId !=""){
        ediTpId =edparDetail.ediTpId.toLowerCase();
      }else{
        ediTpId="";
      }
      if(edparDetail.ediTpShiptoCd != null && edparDetail.ediTpShiptoCd != undefined && edparDetail.ediTpShiptoCd !=""){
        ediTpShiptoCd =edparDetail.ediTpShiptoCd.toLowerCase();
      }else{
        ediTpShiptoCd="";
      }
      if(edparDetail.sapPayerNum != null && edparDetail.sapPayerNum != undefined && edparDetail.sapPayerNum !=""){
        sapPayerNum =edparDetail.sapPayerNum.toLowerCase();
      }else{
        sapPayerNum="";
      }
      if(edparDetail.sapShiptoNum != null && edparDetail.sapShiptoNum != undefined && edparDetail.sapShiptoNum !=""){
        sapShiptoNum =edparDetail.sapShiptoNum.toLowerCase();
      }else{
        sapShiptoNum="";
      }
      if(edparDetail.indirectContactTemplateCd != null && edparDetail.indirectContactTemplateCd != undefined && edparDetail.indirectContactTemplateCd !=""){
        indirectContactTemplateCd =edparDetail.indirectContactTemplateCd.toLowerCase();
      }else{
        indirectContactTemplateCd="";
      }
      if(edparDetail.directOrdersAllowedFlg != null && edparDetail.directOrdersAllowedFlg != undefined && edparDetail.directOrdersAllowedFlg !=""){
        directOrdersAllowedFlg =edparDetail.directOrdersAllowedFlg.toLowerCase();
      }else{
        directOrdersAllowedFlg="";
      }
      if(creationDate.toString().includes(inputSearchingDataCheck)){
        filteredSerachDetails.push(edparDetail);
      }
      else if(ediTpId.includes(inputSearchingDataCheck)){
        filteredSerachDetails.push(edparDetail);
      }
      else if(ediTpShiptoCd.includes(inputSearchingDataCheck)){
        filteredSerachDetails.push(edparDetail);
      }
      else if(sapPayerNum.includes(inputSearchingDataCheck)){
        filteredSerachDetails.push(edparDetail);
      }
      else if(sapShiptoNum.includes(inputSearchingDataCheck)){
        filteredSerachDetails.push(edparDetail);
      }
      else if(indirectContactTemplateCd.includes(inputSearchingDataCheck)){
        filteredSerachDetails.push(edparDetail);
      }
      else if(directOrdersAllowedFlg.includes(inputSearchingDataCheck)){
        filteredSerachDetails.push(edparDetail);
      }
      
    }
    let size = filteredSerachDetails.length;
    if(size !=0){
    this.edpardetails=[];
    this.edpardetails=filteredSerachDetails;
    }else{
      this.isBlank="No Record Found";
      this.edpardetails=this.intialEdiEdparList;
    }

  }
  onSearch(){
    this.clearAllSelection(); 
    // if(this.search != undefined && this.search != null && this.search != "" ){
      if(this.search != undefined && this.search != null){
      this.loading=true;
    this.httpclientService.getEdiEdparDetails(this.search).then(
      data => {
        this.selectedpartner="";
        this.loading=false;
          this.serachdetails=data;
          this.intialEdiEdparList = data;
          this.edpardetails=[];
          this.edpardetails=this.serachdetails;
          this.clonedEdparDetails= Object.assign([{}], this.serachdetails);
          this.clearAllSort();
      }
  )}
  }

  clearAllSort() {
    this.isCreateDateSortCollapsedUpArrow=true;
    this.isCreateDateSortCollapsedDownArrow=true;
    this.isEdiTpIdSortCollapsedUpArrow=true;
    this.isEdiTpIdSortCollapsedDownArrow=true;
    this.isEdiTpShiptoCdSortCollapsedUpArrow=true;
    this.isEdiTpShiptoCdSortCollapsedDownArrow=true;
    this.isSapPayerNumSortCollapsedUpArrow=true;
    this.isSapPayerNumSortCollapsedDownArrow=true;
    this.isSapShiptoNumSortCollapsedUpArrow=true;
    this.isSapShiptoNumSortCollapsedDownArrow=true;
    this.isIndirectContactTemplateCdSortCollapsedUpArrow=true;
    this.isIndirectContactTemplateCdSortCollapsedDownArrow=true;
    this.isDirectOrdersAllowedFlgSortCollapsedUpArrow=true;
    this.isDirectOrdersAllowedFlgSortCollapsedDownArrow=true;
  }
  clearEdparSelection: EdiEdpar[];
  clearAllSelection() {
    this.selectedAllRow = false;
    this.clearEdparSelection = [];
    if(this.edpardetails!=null && this.edpardetails.length>0){
      this.edpardetails.forEach(pdto => {
        pdto.rowCheck = false;
        this.clearEdparSelection.push(pdto);
      });
    }
    
    this.edpardetails = this.clearEdparSelection;
  }

  onSelectAllEdi(values: any) {

    this.edpar = [];
    if (values.currentTarget.checked) {
      this.edpardetails.forEach(pdto => {
        pdto.rowCheck = true;
        this.edpar.push(pdto);
      });
      this.edpardetails = this.edpar;
      this.fileExportService.selectedEdiEdparData = this.edpar;
    } else {
      this.edpardetails.forEach(pdto => {
        console.log('...' + pdto.rowCheck);
        pdto.rowCheck = false;
        this.edpar.push(pdto);
      });
      this.edpardetails = this.edpar;
      this.fileExportService.selectedEdiEdparData = [];
    }

  }

  onSelect(selectedItem: any, values: any) {
    let checkStaus = true;
    if (values.currentTarget.checked) {

      this.fileExportService.selectedEdiEdparData.push(selectedItem);
    } else if (!values.currentTarget.checked) {

      this.fileExportService.selectedEdiEdparData = this.fileExportService.selectedEdiEdparData.filter(obj => obj !== selectedItem);
     
    }

    if(this.fileExportService.selectedEdiEdparData.length === this.edpardetails.length){
      this.selectedAllRow = true;
    }else{ 
      this.selectedAllRow = false;
    }
    

}

  sortArry: EdiEdpar[];
  onChangeSort(event: any, upDown: boolean, propertyName: string) {
    this.intialEdiEdparList = this.edpardetails;
    if (propertyName === 'creationDate' ) {
      this.isEdiTpIdSortCollapsedUpArrow=true;
      this.isEdiTpIdSortCollapsedDownArrow=true;
      this.isEdiTpShiptoCdSortCollapsedUpArrow=true;
      this.isEdiTpShiptoCdSortCollapsedDownArrow=true;
      this.isSapPayerNumSortCollapsedUpArrow=true;
      this.isSapPayerNumSortCollapsedDownArrow=true;
      this.isSapShiptoNumSortCollapsedUpArrow=true;
      this.isSapShiptoNumSortCollapsedDownArrow=true;
      this.isIndirectContactTemplateCdSortCollapsedUpArrow=true;
      this.isIndirectContactTemplateCdSortCollapsedDownArrow=true;
      this.isDirectOrdersAllowedFlgSortCollapsedUpArrow=true;
      this.isDirectOrdersAllowedFlgSortCollapsedDownArrow=true;
      if (upDown) {
    this.sortArry = [];
    this.sortArry = this.pipe.transform(this.intialEdiEdparList, propertyName, upDown);
    this.edpardetails = [];
    this.edpardetails = this.sortArry;
    this.isCreateDateSortCollapsedUpArrow = !this.isCreateDateSortCollapsedUpArrow;
    this.isCreateDateSortCollapsedDownArrow = true;
} else {
  this.sortArry = [];
  this.sortArry = this.pipe.transform(this.intialEdiEdparList, propertyName, upDown);
  this.edpardetails = [];
  this.edpardetails = this.sortArry;
  this.isCreateDateSortCollapsedDownArrow = !this.isCreateDateSortCollapsedDownArrow;
  this.isCreateDateSortCollapsedUpArrow = true;
}
  } else if (propertyName === 'ediTpId' ) {
    this.isCreateDateSortCollapsedUpArrow=true;
    this.isCreateDateSortCollapsedDownArrow=true;
    this.isEdiTpShiptoCdSortCollapsedUpArrow=true;
    this.isEdiTpShiptoCdSortCollapsedDownArrow=true;
    this.isSapPayerNumSortCollapsedUpArrow=true;
    this.isSapPayerNumSortCollapsedDownArrow=true;
    this.isSapShiptoNumSortCollapsedUpArrow=true;
    this.isSapShiptoNumSortCollapsedDownArrow=true;
    this.isIndirectContactTemplateCdSortCollapsedUpArrow=true;
    this.isIndirectContactTemplateCdSortCollapsedDownArrow=true;
    this.isDirectOrdersAllowedFlgSortCollapsedUpArrow=true;
    this.isDirectOrdersAllowedFlgSortCollapsedDownArrow=true;
    if (upDown) {
    this.sortArry = [];
    this.sortArry = this.pipe.transform(this.intialEdiEdparList, propertyName, true);
    this.edpardetails = [];
    this.edpardetails = this.sortArry;
    this.isEdiTpIdSortCollapsedUpArrow = !this.isEdiTpIdSortCollapsedUpArrow;
    this.isEdiTpIdSortCollapsedDownArrow = true;
} else {
  this.sortArry = []; 
  this.sortArry = this.pipe.transform(this.intialEdiEdparList, propertyName, false);
  this.edpardetails = [];
  this.edpardetails = this.sortArry;
  this.isEdiTpIdSortCollapsedDownArrow = !this.isEdiTpIdSortCollapsedDownArrow;
  this.isEdiTpIdSortCollapsedUpArrow = true;
} 
  } else if (propertyName === 'ediTpShiptoCd' ) {
    this.isCreateDateSortCollapsedUpArrow=true;
    this.isCreateDateSortCollapsedDownArrow=true;
    this.isEdiTpIdSortCollapsedUpArrow=true;
    this.isEdiTpIdSortCollapsedDownArrow=true;
    this.isSapPayerNumSortCollapsedUpArrow=true;
    this.isSapPayerNumSortCollapsedDownArrow=true;
    this.isSapShiptoNumSortCollapsedUpArrow=true;
    this.isSapShiptoNumSortCollapsedDownArrow=true;
    this.isIndirectContactTemplateCdSortCollapsedUpArrow=true;
    this.isIndirectContactTemplateCdSortCollapsedDownArrow=true;
    this.isDirectOrdersAllowedFlgSortCollapsedUpArrow=true;
    this.isDirectOrdersAllowedFlgSortCollapsedDownArrow=true;
    if (upDown) {
    this.sortArry = [];
    this.sortArry = this.pipe.transform(this.intialEdiEdparList, propertyName, true);
    this.edpardetails = [];
    this.edpardetails = this.sortArry;
    this.isEdiTpShiptoCdSortCollapsedUpArrow = !this.isEdiTpShiptoCdSortCollapsedUpArrow;
    this.isEdiTpShiptoCdSortCollapsedDownArrow = true;
} else {
  this.sortArry = []; 
  this.sortArry = this.pipe.transform(this.intialEdiEdparList, propertyName, false);
  this.edpardetails = [];
  this.edpardetails = this.sortArry;
  this.isEdiTpShiptoCdSortCollapsedDownArrow = !this.isEdiTpShiptoCdSortCollapsedDownArrow;
  this.isEdiTpShiptoCdSortCollapsedUpArrow = true;
} 
  } else if (propertyName === 'sapPayerNum' ) {
    this.isCreateDateSortCollapsedUpArrow=true;
    this.isCreateDateSortCollapsedDownArrow=true;
    this.isEdiTpIdSortCollapsedUpArrow=true;
    this.isEdiTpIdSortCollapsedDownArrow=true;
    this.isEdiTpShiptoCdSortCollapsedUpArrow=true;
    this.isEdiTpShiptoCdSortCollapsedDownArrow=true;
    this.isSapShiptoNumSortCollapsedUpArrow=true;
    this.isSapShiptoNumSortCollapsedDownArrow=true;
    this.isIndirectContactTemplateCdSortCollapsedUpArrow=true;
    this.isIndirectContactTemplateCdSortCollapsedDownArrow=true;
    this.isDirectOrdersAllowedFlgSortCollapsedUpArrow=true;
    this.isDirectOrdersAllowedFlgSortCollapsedDownArrow=true;
    if (upDown) {
    this.sortArry = [];
    this.sortArry = this.pipe.transform(this.intialEdiEdparList, propertyName, true);
    this.edpardetails = [];
    this.edpardetails = this.sortArry;
    this.isSapPayerNumSortCollapsedUpArrow = !this.isSapPayerNumSortCollapsedUpArrow;
    this.isSapPayerNumSortCollapsedDownArrow = true;
} else {
  this.sortArry = []; 
  this.sortArry = this.pipe.transform(this.intialEdiEdparList, propertyName, false);
  this.edpardetails = [];
  this.edpardetails = this.sortArry;
  this.isSapPayerNumSortCollapsedDownArrow = !this.isSapPayerNumSortCollapsedDownArrow;
  this.isSapPayerNumSortCollapsedUpArrow = true;
} 
  } else if (propertyName === 'sapShiptoNum' ) {
    this.isCreateDateSortCollapsedUpArrow=true;
    this.isCreateDateSortCollapsedDownArrow=true;
    this.isEdiTpIdSortCollapsedUpArrow=true;
    this.isEdiTpIdSortCollapsedDownArrow=true;
    this.isEdiTpShiptoCdSortCollapsedUpArrow=true;
    this.isEdiTpShiptoCdSortCollapsedDownArrow=true;
    this.isSapPayerNumSortCollapsedUpArrow=true;
    this.isSapPayerNumSortCollapsedDownArrow=true;
    this.isIndirectContactTemplateCdSortCollapsedUpArrow=true;
    this.isIndirectContactTemplateCdSortCollapsedDownArrow=true;
    this.isDirectOrdersAllowedFlgSortCollapsedUpArrow=true;
    this.isDirectOrdersAllowedFlgSortCollapsedDownArrow=true;
    if (upDown) {
    this.sortArry = [];
    this.sortArry = this.pipe.transform(this.intialEdiEdparList, propertyName, true);
    console.log("property"+propertyName);
    this.edpardetails = [];
    this.edpardetails = this.sortArry;
    this.isSapShiptoNumSortCollapsedUpArrow = !this.isSapShiptoNumSortCollapsedUpArrow;
    this.isSapShiptoNumSortCollapsedDownArrow = true;
} else {
  this.sortArry = []; 
  this.sortArry = this.pipe.transform(this.intialEdiEdparList, propertyName, false);
  this.edpardetails = [];
  this.edpardetails = this.sortArry;
  this.isSapShiptoNumSortCollapsedDownArrow = !this.isSapShiptoNumSortCollapsedDownArrow;
  this.isSapShiptoNumSortCollapsedUpArrow = true;
} 
   } else if (propertyName === 'indirectContactTemplateCd' ) {
    this.isCreateDateSortCollapsedUpArrow=true;
    this.isCreateDateSortCollapsedDownArrow=true;
    this.isEdiTpIdSortCollapsedUpArrow=true;
    this.isEdiTpIdSortCollapsedDownArrow=true;
    this.isEdiTpShiptoCdSortCollapsedUpArrow=true;
    this.isEdiTpShiptoCdSortCollapsedDownArrow=true;
    this.isSapPayerNumSortCollapsedUpArrow=true;
    this.isSapPayerNumSortCollapsedDownArrow=true;
    this.isSapShiptoNumSortCollapsedUpArrow=true;
    this.isSapShiptoNumSortCollapsedDownArrow=true;
    this.isDirectOrdersAllowedFlgSortCollapsedUpArrow=true;
    this.isDirectOrdersAllowedFlgSortCollapsedDownArrow=true;
    if (upDown) {
    this.sortArry = [];
    this.sortArry = this.pipe.transform(this.intialEdiEdparList, propertyName, true);
    console.log("property"+propertyName);
    this.edpardetails = [];
    this.edpardetails = this.sortArry;
    this.isIndirectContactTemplateCdSortCollapsedUpArrow = !this.isIndirectContactTemplateCdSortCollapsedUpArrow;
    this.isIndirectContactTemplateCdSortCollapsedDownArrow = true;
} else {
  this.sortArry = []; 
  this.sortArry = this.pipe.transform(this.intialEdiEdparList, propertyName, false);
  this.edpardetails = [];
  this.edpardetails = this.sortArry;
  this.isIndirectContactTemplateCdSortCollapsedDownArrow = !this.isIndirectContactTemplateCdSortCollapsedDownArrow;
  this.isIndirectContactTemplateCdSortCollapsedUpArrow = true;
} 
  } else if (propertyName === 'directOrdersAllowedFlg' ) {
    this.isCreateDateSortCollapsedUpArrow=true;
    this.isCreateDateSortCollapsedDownArrow=true;
    this.isEdiTpIdSortCollapsedUpArrow=true;
    this.isEdiTpIdSortCollapsedDownArrow=true;
    this.isEdiTpShiptoCdSortCollapsedUpArrow=true;
    this.isEdiTpShiptoCdSortCollapsedDownArrow=true;
    this.isSapPayerNumSortCollapsedUpArrow=true;
    this.isSapPayerNumSortCollapsedDownArrow=true;
    this.isSapShiptoNumSortCollapsedUpArrow=true;
    this.isSapShiptoNumSortCollapsedDownArrow=true;
    this.isIndirectContactTemplateCdSortCollapsedUpArrow=true;
    this.isIndirectContactTemplateCdSortCollapsedDownArrow=true;
    if (upDown) {
    this.sortArry = [];
    this.sortArry = this.pipe.transform(this.intialEdiEdparList, propertyName, true);
    console.log("property"+propertyName);
    this.edpardetails = [];
    this.edpardetails = this.sortArry;
    this.isDirectOrdersAllowedFlgSortCollapsedUpArrow = !this.isDirectOrdersAllowedFlgSortCollapsedUpArrow;
    this.isDirectOrdersAllowedFlgSortCollapsedDownArrow = true;
} else {
  this.sortArry = []; 
  this.sortArry = this.pipe.transform(this.intialEdiEdparList, propertyName, false);
  this.edpardetails = [];
  this.edpardetails = this.sortArry;
  this.isDirectOrdersAllowedFlgSortCollapsedDownArrow = !this.isDirectOrdersAllowedFlgSortCollapsedDownArrow;
  this.isDirectOrdersAllowedFlgSortCollapsedUpArrow = true;
} 
  } 

  }
  sapPayerNumOriginal:string;
  ediTpShiptoCdOriginal:string;
  enablingupdate(edpardto){
    this.isedparupdated='';
    this.updatedediedpar=true;
    this.ediTpId =edpardto.ediTpId;
    this.ediTpShiptoCd = edpardto.ediTpShiptoCd;
    this.ediTpShiptoCdOriginal= edpardto.ediTpShiptoCd;
    this.sapPayerNum = edpardto.sapPayerNum;
    this.sapPayerNumOriginal = edpardto.sapPayerNum;
    this.sapShiptoNum = edpardto.sapShiptoNum;
    this.indirectContactTemplateCd = edpardto.indirectContactTemplateCd;
     this.directOrdersAllowedFlg = edpardto.directOrdersAllowedFlg;
  }

  updateedpar(){
    this.isedparupdated="";
    if(this.ediTpShiptoCd == "" || this.ediTpShiptoCd== null || this.ediTpShiptoCd== undefined ){
      this.isedparupdated="Please Enter EDI Ship To";
      return ;
    }
    if(this.sapPayerNum=="" || this.sapPayerNum== null || this.sapPayerNum== undefined  ){
      this.isedparupdated="Please Enter SAP Payer No.";
      return ;
    }
    if(this.sapShiptoNum=="" || this.sapShiptoNum== null || this.sapShiptoNum== undefined  ){
      this.isedparupdated="Please Enter SAP Ship To";
      return ;
    }
    
    let updatingediedpar : EdiEdpar = new EdiEdpar(this.ediTpId,this.ediTpShiptoCd,this.sapPayerNum,this.sapShiptoNum,this.indirectContactTemplateCd,this.directOrdersAllowedFlg,this.sapPayerNumOriginal,this.ediTpShiptoCdOriginal);
    this.loading=true;
    this.httpclientService.updateediedpar(updatingediedpar).subscribe(
      data =>{
        this.isedparupdated=data.isSaved;
        this.sapPayerNumOriginal=this.sapPayerNum;
        this.ediTpShiptoCdOriginal=this.ediTpShiptoCd;
        this.loading=false;
      }
  )

  }

  cancelUpdate(){
    
    this.modalPopup=true;
  }

  clearField(){
    this.isedparupdated="";
  }
  
  // showDialog() { 
  //   this.isedparupdated=""; 
  //   this.confirmDialogService.confirmThis("Are you sure You want to Cancel?", function () {  
  //     this.updatedediedpar = false;
  //     this.getediEdpar();
  //   }, function () {  
       
  //   })  
  // } 

  getediEdpar(){
    this.loading=true;
    this.httpclientService.getEdiEdparDetails(this.search).then(
      data =>{
          this.edpardetails = data;
          console.log(this.edpardetails);
          this.intialEdiEdparList= data;
          this.loading=false;
      }
  )
  }

}
